import { Input, notification } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const RenameInput = ({ menuName, externalRef, onSave }) => {
  const { t } = useTranslation('home');
  const [value, setValue] = useState(menuName);

  const handleSave = e => {
    e.stopPropagation();
    if (!value.trim() || value.length < 1) {
      showValidationError();
      return;
    }
    onSave(externalRef, value);
  };
  const showValidationError = () => {
    notification.open({
      // 3. 使用 t 函数翻译 message
      message: t('renameInput.notification.title'),
      // 3. 使用 t 函数翻译 description
      description: t('renameInput.notification.description'),
      duration: 3,
    });
  };

  return (
    <Input
      value={value}
      onChange={e => setValue(e.target.value)}
      onBlur={handleSave}
      onPressEnter={handleSave}
      autoFocus
    />
  );
};

export default RenameInput;
